import React, { useState } from 'react';
import { FiMapPin, FiPhone, FiMail, FiClock } from 'react-icons/fi';
import './Contact.css';

const hoursData = [
  { day: 'Monday', time: '8:00 AM - 5:30 PM' },
  { day: 'Tuesday', time: '8:00 AM - 5:30 PM' },
  { day: 'Wednesday', time: '8:00 AM - 5:30 PM' },
  { day: 'Thursday', time: '8:00 AM - 5:30 PM' },
  { day: 'Friday', time: '8:00 AM - 5:30 PM' },
  { day: 'Saturday', time: '9:00 AM - 12:00 PM' },
  { day: 'Sunday', time: 'CLOSED' }
];

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const [status, setStatus] = useState('idle'); // idle, sending, success, error

  const handleSubmit = (e) => {
    e.preventDefault();
    const subject = encodeURIComponent(`Free Estimate Request from ${formData.name}`);
    const body = encodeURIComponent(
      `Name: ${formData.name}\nEmail: ${formData.email}\nPhone: ${formData.phone}\n\nMessage:\n${formData.message}`
    );
    window.location.href = `mailto:info@axiscollisioncenter.com?subject=${subject}&body=${body}`;
    setStatus('success');
    setFormData({ name: '', email: '', phone: '', message: '' });
    setTimeout(() => setStatus('idle'), 5000);
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <section id="contact" className="contact section">
      <div className="container">
        <div className="contact__header">
          <h2 className="contact__title">Contact Us</h2>
          <p className="contact__subtitle">
            Get in touch for a free estimate or to schedule your repair
          </p>
        </div>
        <div className="contact__grid">
          <div className="contact__info">
            <div className="contact__map">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3449.8!2d-95.51!3d30.06!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8647380e0!2s20923%20Holzwarth%20Rd%2C%20Spring%2C%20TX%2077388!5e0!3m2!1sen!2sus!4v1234567890"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Axis Collision Center - 20923 Holzwarth Road, Spring, TX 77388"
              ></iframe>
            </div>
            <div className="contact__details">
              <div className="contact__item">
                <div className="contact__item-icon">
                  <FiMapPin />
                </div>
                <div className="contact__item-content">
                  <div className="contact__item-label">Address</div>
                  <div className="contact__item-value">
                    20923 Holzwarth Road<br />
                    Spring, TX 77388
                  </div>
                  <a 
                    href="https://maps.google.com/?q=20923+Holzwarth+Road,+Spring,+TX+77388" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="contact__item-link"
                  >
                    Get Directions →
                  </a>
                </div>
              </div>
              <div className="contact__item">
                <div className="contact__item-icon">
                  <FiPhone />
                </div>
                <div className="contact__item-content">
                  <div className="contact__item-label">Phone</div>
                  <a href="tel:+18326156065" className="contact__item-value contact__item-value--link">
                    (832) 615-6065
                  </a>
                </div>
              </div>
              <div className="contact__item">
                <div className="contact__item-icon">
                  <FiMail />
                </div>
                <div className="contact__item-content">
                  <div className="contact__item-label">Email</div>
                  <a href="mailto:info@axiscollisioncenter.com" className="contact__item-value contact__item-value--link">
                    info@axiscollisioncenter.com
                  </a>
                </div>
              </div>
              <div className="contact__item">
                <div className="contact__item-icon">
                  <FiClock />
                </div>
                <div className="contact__item-content">
                  <div className="contact__item-label">Hours of Operation</div>
                  <div className="contact__hours">
                    {hoursData.map((hour, index) => (
                      <div key={index} className="contact__hours-row">
                        <span className="contact__hours-day">{hour.day}</span>
                        <span className="contact__hours-time">{hour.time}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="contact__form-wrapper">
            <h3 className="contact__form-title">Request a Free Estimate</h3>
            <form className="contact__form" onSubmit={handleSubmit}>
              <div className="form-group">
                <input
                  type="text"
                  name="name"
                  id="contact-name"
                  placeholder="Your Name *"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  autoComplete="name"
                  className="form-input"
                  aria-label="Your name"
                />
              </div>
              <div className="form-group">
                <input
                  type="email"
                  name="email"
                  id="contact-email"
                  placeholder="Your Email *"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  autoComplete="email"
                  className="form-input"
                  aria-label="Your email address"
                />
              </div>
              <div className="form-group">
                <input
                  type="tel"
                  name="phone"
                  id="contact-phone"
                  placeholder="Your Phone Number *"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                  autoComplete="tel"
                  className="form-input"
                  aria-label="Your phone number"
                />
              </div>
              <div className="form-group">
                <textarea
                  name="message"
                  id="contact-message"
                  placeholder="Tell us about your vehicle and repair needs *"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows="6"
                  className="form-input form-textarea"
                  aria-label="Your message about repair needs"
                ></textarea>
              </div>
              <button type="submit" className="btn btn--primary btn--full" aria-label="Submit contact form" disabled={status === 'sending'}>
                {status === 'sending' ? 'Sending...' : status === 'success' ? 'Message Sent!' : 'Send Message'}
              </button>
              {status === 'success' && (
                <p style={{ color: '#16a34a', marginTop: '12px', textAlign: 'center', fontWeight: 600 }}>
                  Thank you! We'll contact you soon. Or call us now at (832) 615-6065.
                </p>
              )}
              {status === 'error' && (
                <p style={{ color: '#dc2626', marginTop: '12px', textAlign: 'center' }}>
                  Something went wrong. Please call us directly at <a href="tel:+18326156065">(832) 615-6065</a>.
                </p>
              )}
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
